import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export function transitionOpen(selector, element, triggers, target) {
  triggers = Array.isArray(triggers) ? triggers : [triggers]

  return new Promise((resolve) => {
    const isOpen = element.classList.contains(`${selector}-open`)

    if (isOpen) {
      resolve()
      return
    }


    if (triggers) {
      //console.log(triggers)

      triggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'true')
      })
    }

    if (target) {
      target.setAttribute('aria-hidden', 'false')
    }



    element.classList.add(`${selector}-pre-open`)
    setTimeout(() => {
      element.classList.add(`${selector}-open`)
      resolve()
    }, 0)
  })
}

export function transitionClose(selector, element, triggers, target) {
  triggers = Array.isArray(triggers) ? triggers : [triggers]

  return new Promise((resolve) => {
    const isOpen = element.classList.contains(`${selector}-open`)

    if (!isOpen) {
      resolve()
      return
    }

    if (triggers) {
      triggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false')
      })
    }

    if (target) {
      target.setAttribute('aria-hidden', 'true')
    }

    element.classList.remove(`${selector}-open`)
    setTimeout(() => {
      element.classList.remove(`${selector}-pre-open`)
      resolve()
    }, 300)
  })
}

let floatingWidgetsWereVisible = false

export function mayHideFloatingButtons() {
  if (document.body.classList.contains('floating-buttons-visible')) {
    floatingWidgetsWereVisible = true
    document.body.classList.remove('floating-buttons-visible')
  }
}

export function restoreFloatingButtons() {
  if (floatingWidgetsWereVisible) {
    document.body.classList.add('floating-buttons-visible')
    floatingWidgetsWereVisible = false
  }
}

export function bodyLock(parentElement) {
  const overlayContent = parentElement.querySelector('.overlay-widget-content')
  if (overlayContent) {
    disableBodyScroll(overlayContent)
  }
}


